import apiClient from '../client';
import ENDPOINTS from '../endpoints';

const authService = {
  /* Starts passwordless login: sends the OTP to the phone. The API wants a
     reCAPTCHA token on every send, including resends from the code screen. */
  sendOtp: (username, recaptchaToken) =>
    apiClient.post(ENDPOINTS.AUTH.OTP_INITIATE, {
      username,
      ...(recaptchaToken ? { recaptchaToken } : {}),
    }),

  verifyOtp: (username, otp) => apiClient.post(ENDPOINTS.AUTH.OTP_VERIFY, { username, otp }),

  logout: () => apiClient.post(ENDPOINTS.AUTH.LOGOUT),
};

export default authService;
